exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{\r\n    font-size: 30px;\r\n}\r\n.text-date{\r\n    font-size: 1rem;\r\n}\r\n.facebook-box{\r\n    width: 100%;\r\n    height: 2rem;\r\n    overflow: hidden;\r\n    border-radius: 5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-item-promotion-news/detail-item-promotion-news.component.css
// module id = ../../../../../src/app/components/detail-item-promotion-news/detail-item-promotion-news.component.css
// module chunks = main